export enum Color {
  WHITE = '#ffffff',
  RED = '#ff0000',
  BLUE = '#0000ff',
  GREEN = '#00ff00',
  YELLOW = '#ffff00',
  BLACK = '#000000'
}
